import { AdminRouteName } from '../../../CONSTANTS';
import GuaranteesTableRecords from '../../_partials/GuaranteesTableRecords';

const optionalColumn = [
  'datePaid',
  'dateActioned',
];

const optionalColumnLabelFormat = {
  datePaid: 'Date Paid',
  dateActioned: 'Date Actioned',
};

const AllPreApprovalGuarantees = (
  { TabsRaw }: any,
) => (
  <GuaranteesTableRecords
    type="pre-approval"
    TabsRaw={TabsRaw}
    optionalColumn={optionalColumn}
    optionalColumnLabelFormat={optionalColumnLabelFormat}
    defaultUrl={AdminRouteName.allPreApprovalGuaranteesRoute}
    toggleStorageId="all_pre_approval_guarantees-table-col"
    hasNameAndImage
    permissionName="can-view-all-guarantees-tab"
  />
);
export default AllPreApprovalGuarantees;
